import { OfflineDetectionService } from '@core/services/network/offline-detection.service';
import { ServerReachabilityService } from '@core/services/network/server-reachability.service';
import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';

export type ConnectivityAlertKind = 'offline' | 'server';

/**
 * Modale applicativa bloccante (Bootstrap) per assenza Internet o server API irraggiungibile.
 * Priorità: offline > server. Vedi `docs/NETWORK_CONNECTIVITY.md`.
 * Icone SVG inline (copie di `public/icons/wifi-off.svg` / `cloud-slash.svg`) per funzionare anche offline.
 */
@Component({
  selector: 'app-connectivity-alert-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './connectivity-alert-modal.component.html',
  styleUrl: './connectivity-alert-modal.component.css',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ConnectivityAlertModalComponent {
  private readonly offlineDetection = inject(OfflineDetectionService);
  private readonly serverReachability = inject(ServerReachabilityService);

  readonly kind = computed<ConnectivityAlertKind | null>(() => {
    if (this.offlineDetection.isOffline()) {
      return 'offline';
    }
    if (this.serverReachability.isUnreachable()) {
      return 'server';
    }
    return null;
  });

  readonly retrying = this.serverReachability.retrying;

  onRetry(): void {
    this.serverReachability.retryCheck().subscribe({
      error: () => {
        /* stato già aggiornato dal servizio */
      }
    });
  }
}
